import React, {forwardRef, useState} from 'react';
import {Collapse} from 'antd';

const keysOf = value => (value == null ? [] : Array.isArray(value) ? value : [value]).map(String);

// rc-collapse 3.7's header-only mode separates extras, but removes the heading's
// keyboard target. Supply a native button without adding a second toggle path.
const AccessibleCollapse = forwardRef(function AccessibleCollapse(props, ref) {
    const [localKeys, setLocalKeys] = useState(props.defaultActiveKey);
    const activeKeys = keysOf(props.activeKey === undefined ? localKeys : props.activeKey);
    const heading = (label, key, mode) => mode !== 'header' ? label : <button
        type="button" className="collapse-heading-control"
        aria-expanded={activeKeys.includes(String(key))}
        style={{background: 'none', border: 0, padding: 0, font: 'inherit', color: 'inherit', textAlign: 'start', width: '100%', cursor: 'pointer'}}
        onKeyDown={event => { if(event.key === 'Enter' || event.key === ' ') event.stopPropagation(); }}
    >{label}</button>;
    const changed = keys => { setLocalKeys(keys); props.onChange?.(keys); };
    const modeFor = panel => panel.disabled ? 'disabled' : panel.collapsible ?? props.collapsible;

    const items = props.items?.map((item, index) => {
        const mode = modeFor(item);
        return {...item, collapsible: mode, label: heading(item.label, item.key ?? String(index), mode)};
    });

    // Unlike Children.toArray(), forEach preserves explicit keys. Flatten the
    // fragments/arrays that rc-collapse also flattens before assigning indices.
    const panels = [];
    const collect = children => React.Children.forEach(children, child => {
        if(child?.type === React.Fragment) collect(child.props.children);
        else if(child != null) panels.push(child);
    });
    collect(props.children);
    const children = panels.map((panel, index) => {
        if(!React.isValidElement(panel)) return panel;
        const mode = modeFor(panel.props);
        return React.cloneElement(panel, {key: panel.key ?? String(index), collapsible: mode,
            header: heading(panel.props.header, panel.key ?? String(index), mode)});
    });

    return <Collapse {...props} ref={ref} onChange={changed} items={items}>{props.children ? children : undefined}</Collapse>;
});

AccessibleCollapse.Panel = Collapse.Panel;
export default AccessibleCollapse;
